<template>
	<div class="rule">
		<ul class="step">
    		<li class="step-arrow"></li>
        	<li class="step-text">填写订单</li>
        	<li class="step-arrow"></li>
        	<li class="step-text ">订单支付</li>
        	<li class="step-arrow "></li>
        	<li class="step-text">订单完成</li>
    	</ul>
    	<div class="information">
    		<div class="pay">
    			<div class="pay-img">
    				<img src="./../../../assets/img/img19.png" alt="" />
    			</div>
         
                <div class="pay-content" v-if="order.SettlementType!=1&&order.Status>=10">
                    <p class="one">订单号: <span>{{OrderNO}}</span></p>
                    <p class="two">信贷账户已扣减
                    </p>
                    <p class="three-a">订单提交成功并已确认！
                    </p>
                    <div class="btn"><i class="iconfont icon-print"></i>打印预订单</div>
                </div>
                <div class="pay-content" v-if="order.SettlementType!=1&&order.Status<10">
                    <p class="one">订单号: <span>{{OrderNO}}</span></p>
                
                    <p class="three-a">订单提交成功等待确认！
                    </p>
                    <div class="btn"><i class="iconfont icon-print"></i>打印预订单</div>
                </div>

    			<div class="pay-content" v-if="order.SettlementType==1">
    				<p class="one">订单号: <span>{{OrderNO}}</span></p>

                    <p class="two" v-if="order.PaymentType<=2">
                        订单未支付
                        <span class="book-unpay" @click="topay">去支付</span>

                    </p>
                        
    			    <p class="two" v-else>订单支付成功</p>

                    <p class="three-a" v-if="order.Status>=10">订单已确认</p>
    				<p class="three-a colorRed" v-if="order.Status<10">订单正在处理中,详情请联系订房易客服</p>

    				<div class="btn"><i class="iconfont icon-print"></i>打印预订单</div>
    			</div>


    		</div>
    	</div>
    	<div class="information-a">
    
    		<table>
    			<thead>
    				<tr>
    					<td width="22%">景点名称</br>门票名称</td>
    					<td width="13%">游玩日期</td>
    					<td width="20%">游客名称</td>
    					<td width="10%">张数</td>
    					<td width="15%">订单状态</td>
    					<td width="10%">总金额</td>
    					<td width="10%">详情</td>
    				</tr> 
    			</thead>
    			<tbody> 
    				<tr> 
    					<td>
                            {{order.HotelName||order.HotelName}}</br>
                            {{order.RoomName}}
                        </td>
    					<td>
                            {{order.CheckInStr|dateToYMDline}}</br>
                            {{order.CheckOutStr|dateToYMDline}}
                        </td>
    					<td>
                            <div v-for="guest in order.Guest">{{guest.FirstName}} {{guest.LastName}} </div>
                        </td>
    					<td>{{order.RoomCount}}</td>
    					<td>
                            <span v-show="order.Status=='0'">无效单</span>
                            <span v-show="order.Status=='9'" class="colorRed">新单(等待确认)</span>
                            <span v-show="order.Status=='8'">取消单</span>
                            <span v-show="order.Status=='10'">已确认</span>
                            <span v-show="order.Status=='27'">可入住</span>
                        </td>
    					<td>{{Currency}} {{order.TotalAmount}}</td>
    					<td><span class="link-a" @click="toOrder" >详情</span></td>
    				</tr>
    			</tbody>
    		</table>
    	</div>
    	<div class="information-b">
    		<div class="button">
    			<div class="btn" @click="toHome">返回首页</div>
    			<div class="return" @click="toOrder">订单管理</div>
    		</div>
    	</div>
	</div>
</template>
<script>
	export default{
		name:'book-complete',
		data(){
			return{
                Currency: this.dao.get('userInfo').Currency,
								userInfo:this.dao.get('userInfo'),
                bookInfo:this.dao.get('bookInfo'),
                OrderNO:this.$route.query.OrderNO,
             
                order:'',
			}
		},
		methods:{
            getOrderData(){
                var that = this;
                var param={
                    OrderNO:that.$route.query.OrderNO
                }
                that.getRequest({
                    url: that.Api.getOrderDetails,
                    params:param
                }).then(res => {
                    if (res && res.IsSuccess) {
                   
                        that.order = res.Result
                    } else {
                        that.error({title:'提示',content:'获取订单状态出错，请刷新页面重试'});
                    }
                });
            },
            topay(){
                this.$router.push('/ticketBookComfirm?OrderNO='+this.OrderNO)
            },
			toHome(){
				this.$router.push('/');
			},
			toOrder(){
                  window.open('#/orderDetails/'+this.OrderNO, '_blank');
				// this.$router.push('/orderDetails/'+this.OrderNO);
			}

		},
        mounted(){
             document.title='预定完成---订房易';
             this.getOrderData();
        }

	}
</script>


// WEBPACK FOOTER //
// src/components/ticket/book/bookComplete.vue